import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 8EA23E11-D670-4D09-8AA6-7DAFBEAA54FD
 * name table-row
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/table-row.svg
 * tags
 * - Text / Content / Format 
 */
export const TableRowIcon = createSvgIcon(<><path d="M22,14A2,2 0 0,1 20,16H4A2,2 0 0,1 2,14V10A2,2 0 0,1 4,8H20A2,2 0 0,1 22,10V14M4,14H8V10H4V14M10,14H14V10H10V14M16,14H20V10H16V14Z" /></>, 'TableRowIcon');
export default TableRowIcon